import React, { useEffect, useState } from 'react';
import NavContainer from './Nav';
import OffCanvasNav from './OffCanvasNav';
import { Alert, Button, Col, Container, Form, Row, Table } from 'react-bootstrap';
import Titulo from '../elements/Titulo';
import { dotoniwoofApi } from '../api/dotoniwooApi';
import { useAuth } from '../context/AuthContext';
import { Helmet } from 'react-helmet';
import AlertModal from './AlertModal';
import useAlertModal from '../hooks/useAlertModal';

const SupplierManagment = () => {

    const { user } = useAuth();
    const [dataResponse, setDataResponse] = useState([]);
    const [suppliers, setSuppliers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);

    const [supplierData, setSupplierData] = useState({
        name: '',
        address: '',
        phone: '',
        email: ''
    });




    const { showAlert, showAlertModal, alertMessage, alertType, hideAlert } = useAlertModal();


    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setSupplierData({
            ...supplierData,
            [name]: value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const { data } = await dotoniwoofApi.post("/supplier.php",
                JSON.stringify({
                    firebase_UID: user.uid,
                    name: supplierData.name,
                    address: supplierData.address,
                    phone: supplierData.phone,
                    email: supplierData.email
                }));
            setDataResponse(data);
            if (data.code === 201) {
                showAlert(data.message || 'Proveedor creado exitosamente', 'success');
                setSupplierData({ name: '', address: '', phone: '', email: '' });
            } else {
                throw new Error('Failed to save category type');
            }
        } catch (error) {
            showAlert('Error al crear el proveedor. Por favor, intente nuevamente.', 'error');
        }
    };

    useEffect(() => {

        const fetchSuppliers = async () => {
            await dotoniwoofApi.get(`/supplier.php`)
                .then(res => {
                    let responseApi = res.data;
                    if (responseApi.code === 200) {
                        setSuppliers(responseApi.message);
                    }
                })
                .catch(err => {
                    console.log(err);
                }).finally(
                    () => {
                        setLoading(false);
                    }
                )
        }
        fetchSuppliers();
    }, []);

    return (
        <>
            <NavContainer></NavContainer>
            <OffCanvasNav></OffCanvasNav>
            <Helmet><title>
                Proveedores
            </title></Helmet>

            <Container>
                <Titulo>Configuración de proveedores</Titulo>
                <hr></hr>
                <Row>
                    <Col>
                        <Container>
                            <h4>Creación de proveedor</h4>
                            <br></br>
                            <Form onSubmit={handleSubmit}>
                                {/* Nombre del Proveedor */}
                                <Form.Group controlId="formSupplierName">
                                    <Form.Label><strong>Nombre</strong></Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="name"
                                        value={supplierData.name}
                                        onChange={handleInputChange}
                                        placeholder="Digite el nombre del proveedor"
                                        required
                                    />
                                </Form.Group>

                                {/* Dirección del Proveedor */}
                                <Form.Group controlId="formSupplierAddress">
                                    <Form.Label><strong>Dirección</strong></Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="address"
                                        value={supplierData.address}
                                        onChange={handleInputChange}
                                        placeholder="Digite la direccion del proveedor"
                                        required
                                    />
                                </Form.Group>

                                {/* Teléfono del Proveedor */}
                                <Form.Group controlId="formSupplierPhone">
                                    <Form.Label><strong>Teléfono</strong></Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="phone"
                                        value={supplierData.phone}
                                        onChange={handleInputChange}
                                        placeholder="Digite el telefono del proveedor"
                                        required
                                    />
                                </Form.Group>

                                {/* Correo electrónico del Proveedor */}
                                <Form.Group controlId="formSupplierEmail">
                                    <Form.Label><strong>Correo</strong></Form.Label>
                                    <Form.Control
                                        type="email"
                                        name="email"
                                        value={supplierData.email}
                                        onChange={handleInputChange}
                                        placeholder="Digite el correo del proveedor"
                                        required
                                    />
                                </Form.Group>

                                <br></br>

                                {/* Botón de envío */}
                                <Button variant="primary" type="submit">
                                    Crear proveedor
                                </Button>
                            </Form>

                            <br></br>

                            {/* Tabla de proveedores */}
                            {!loading && !error && suppliers.length > 0 && (
                                <Table striped bordered hover>
                                    <thead>
                                        <tr>
                                            <th>Proveedor</th>
                                            <th>Dirección</th>
                                            <th>Telefono</th>
                                            <th>Correo</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {suppliers.map((supplier) => (
                                            <tr key={supplier.id_supplier}>
                                                <td>{supplier.name}</td>
                                                <td>{supplier.address}</td>
                                                <td>{supplier.phone}</td>
                                                <td>{supplier.email}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            )}

                            {/* Mensaje cuando no se encuentran proveedores */}
                            {!loading && suppliers.length === 0 && (
                                <Alert variant="info">
                                    No existen proveedores
                                </Alert>
                            )}

                        </Container>

                    </Col>
                </Row>
            </Container>


            {/* Modal de Alerta Temporal */}
            <AlertModal
                show={showAlertModal}
                onHide={hideAlert}
                message={alertMessage}
                type={alertType}
            />
        </>
    );
}

export default SupplierManagment;